import { IllumiLogoMark } from "./illumi-logo-mark";

export function IllumiLoadingScreen() {
	return (
		<div
			className="flex min-h-dvh w-full items-center justify-center bg-surface-app"
			aria-live="polite"
			aria-busy="true"
			aria-label="Loading illumi"
		>
			<IllumiLogoMark animated />
		</div>
	);
}
